const pad2 = (num: number) => String(num).padStart(2, '0');

const initHolder = (holder: HTMLElement) => {
  if (holder.dataset.bfCountdownInitialized === 'true') return;
  const targetStr = holder.getAttribute('data-target');
  if (!targetStr) return;

  const target = new Date(targetStr);
  const elDays = holder.querySelector<HTMLElement>('[data-days]');
  const elHours = holder.querySelector<HTMLElement>('[data-hours]');
  const elMinutes = holder.querySelector<HTMLElement>('[data-minutes]');
  const elSeconds = holder.querySelector<HTMLElement>('[data-seconds]');
  if (!elDays || !elHours || !elMinutes || !elSeconds) return;

  const update = () => {
    const now = new Date();
    const diffMs = target.getTime() - now.getTime();
    if (diffMs <= 0) {
      elDays.textContent = '0';
      elHours.textContent = '00';
      elMinutes.textContent = '00';
      elSeconds.textContent = '00';
      return;
    }
    const totalSeconds = Math.floor(diffMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    elDays.textContent = String(days);
    elHours.textContent = pad2(hours);
    elMinutes.textContent = pad2(minutes);
    elSeconds.textContent = pad2(seconds);
  };

  update();
  const id = window.setInterval(update, 1000);
  holder.dataset.bfCountdownInitialized = 'true';
  holder.addEventListener('countdown:destroy', () => window.clearInterval(id), { once: true });
};

export const initBfCountdown = (root: ParentNode | Document = document) => {
  const holders = root.querySelectorAll?.<HTMLElement>('[data-bf-countdown]');
  if (!holders || !holders.length) return;
  holders.forEach(initHolder);
};

